/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandBinance = createReactComponent("brand-binance", "IconBrandBinance", [
  ["path", { d: "M6 8l2 2l4 -4l4 4l2 -2l-6 -6z", key: "svg-0" }],
  ["path", { d: "M6 16l2 -2l4 4l3.5 -3.5l2 2l-5.5 5.5z", key: "svg-1" }],
  ["path", { d: "M20 10l2 2l-2 2l-2 -2z", key: "svg-2" }],
  ["path", { d: "M4 10l2 2l-2 2l-2 -2z", key: "svg-3" }],
  ["path", { d: "M12 10l2 2l-2 2l-2 -2z", key: "svg-4" }]
]);

export { IconBrandBinance as default };
//# sourceMappingURL=IconBrandBinance.js.map
